export enum MODAL_STATE {
  OPEN = 'MODAL_OPEN',
  CLOSE = 'MODAL_CLOSE',
}

export enum MODAL_TYPES {
  BORROW_REPAY = 'BORROW_REPAY',
  CHANGE_NICKNAME = 'CHANGE_NICKNAME',
  DELETE_TRUST_DEVICE = 'DELETE_TRUST_DEVICE',
  EMAIL_CHANGE_VERIFICATION = 'EMAIL_CHANGE_VERIFICATION',
  MARGIN_TRANSFER = 'MARGIN_TRANSFER',
  SELECT_CURRENCY = 'SELECT_CURRENCY',
  REQUEST_APPROVED = 'REQUEST_APPROVED',
  FUND_ACCOUNT = 'FUND_ACCOUNT',
  CONFIRM_MODAL = 'CONFIRM_MODAL',
  MARKETS_MODAL = 'MARKETS_MODAL',
  ORDERS_LEFT_MODAL = 'ORDERS_LEFT_MODAL',
  SIMPLE_EARN_MODAL = 'SIMPLE_EARN_MODAL',
  P2P_OFFER_CONFIRM_MODAL = 'P2P_OFFER_CONFIRM_MODAL',
  P2P_OFFER_CREATED_MODAL = 'P2P_OFFER_CREATED_MODAL',
  SELECT_P2P_PAY_METHOD = 'SELECT_P2P_PAY_METHOD',
  SELECT_P2P_ACCOUNT = 'SELECT_P2P_ACCOUNT',
  ADD_P2P_PAY_ACCOUNT = 'ADD_P2P_PAY_ACCOUNT',
  P2P_PAYMENT_CONFIRMATION = 'P2P_PAYMENT_CONFIRMATION',
  NOTIFICATION_INFO = 'NOTIFICATION_INFO',
  TERMS_AND_CONDITIONS = 'TERMS_AND_CONDITIONS',
  NONE = 'NONE',
  LOAN_BORROW_MODAL = 'LOAN_BORROW_MODAL',
  RENEWAL_MODAL = 'RENEWAL_MODAL',
  LOAN_REPAY_MODAL = 'LOAN_REPAY_MODAL',
  LOAN_ADJUST_LTV_MODAL = 'LOAN_ADJUST_LTV_MODAL',
  LOGIN_MODAL = 'LOGIN_MODAL',
  USER_SETTINGS_MODAL = 'USER_SETTINGS_MODAL',
  MARKETS_LIST_MODAL = 'MARKETS_LIST_MODAL',
  FORGOT_PASSWORD_MODAL = 'FORGOT_PASSWORD_MODAL',
  FORGOT_USERNAME_MODAL = 'FORGOT_USERNAME_MODAL',
  REGISTRATION_MODAL = 'REGISTRATION_MODAL',
  CLOSE_ACCOUNT_MODAL = 'CLOSE_ACCOUNT_MODAL',
  CLOSE_ACCOUNT_MULTIPLE_MODAL = 'CLOSE_ACCOUNT_MULTIPLE_MODAL',
  CHECK_MONTH_STATS_AFTER_LOGIN_MODAL = 'CHECK_MONTH_STATS_AFTER_LOGIN_MODAL',
  EXCLUDE_KYC_MODAL = 'EXCLUDE_KYC_MODAL',
  FREEZE_PERIOD_MODAL = 'FREEZE_PERIOD_MODAL',
  INACTIVITY_NOTICE_MODAL = 'INACTIVITY_NOTICE_MODAL',
  UPDATE_TERMS_AND_CONDITIONS_MODAL = 'UPDATE_TERMS_AND_CONDITIONS_MODAL',
  SESSION_TIMEOUT_MODAL = 'SESSION_TIMEOUT_MODAL',
  JURISDICTION_MODAL = 'JURISDICTION_MODAL',
  REALITY_CHECK_PERIOD_MODAL = 'REALITY_CHECK_PERIOD_MODAL',
  TRAIDING_OPTIONS_MODAL = 'TRAIDING_OPTIONS_MODAL',
  PLAY_SAFE_DEPOSIT_LIMIT_MODAL = 'PLAY_SAFE_DEPOSIT_LIMIT_MODAL',
  PLAY_SAFE_BET_LIMIT_MODAL = 'PLAY_SAFE_BET_LIMIT_MODAL',
  PLAY_SAFE_LOSS_LIMIT_MODAL = 'PLAY_SAFE_LOSS_LIMIT_MODAL',
  PLAY_SAFE_REALITY_CHECK_MODAL = 'PLAY_SAFE_REALITY_CHECK_MODAL',
  PLAY_SAFE_SELF_EXCLUSION_MODAL = 'PLAY_SAFE_SELF_EXCLUSION_MODAL',
  PLAY_SAFE_SESSION_TIMEOUT_MODAL = 'PLAY_SAFE_SESSION_TIMEOUT_MODAL',
  SWITCH_ACCOUNT_MODAL = 'SWITCH_ACCOUNT_MODAL',
  CHOOSE_ACCOUNT_CURRENCY_MODAL = 'CHOOSE_ACCOUNT_CURRENCY_MODAL',
  ACCOUNT_CREATED_MODAL = 'ACCOUNT_CREATED_MODAL',
  EDIT_ACCOUNT_NAME_MODAL = 'EDIT_ACCOUNT_NAME_MODAL',
  SEND_REPORT_MODAL = 'SEND_REPORT_MODAL',
  UPDATE_DOCUMENTS_MODAL = 'UPDATE_DOCUMENTS_MODAL',
  PROBLEM_GAMBLER_MODAL = 'PROBLEM_GAMBLER_MODAL',
}

export enum MODAL_LOGOUT_TYPE {
  SESSION_TIMEOUT = 'session_timeout',
  CLOSE_ACCOUNT = 'user_not_active',
  CLOSE_MULTIPLE_ACCOUNT = 'session_not_equal',
  INACTIVITY_TIME = 'inactivity_time',
  SESSION_IS_NOT_VALID = 'session_is_not_valid',
}
